import { useSession } from './useSession';

export const useIsAuthed = () => {
  const { state: sessionState } = useSession();
  const isAuthed = sessionState?.context?.auth;

  return isAuthed;
};
